module.exports = __webpack_public_path__ + "images/emoji/video_game.7bee147574be77721aaf.png";